export const MAX_INPUT_TIME_AFTER_TEST_VALUE = 180 // minutes
export const DEFAULT_TIME_AFTER_TEST = { value: 300, label: '5' }

// Fixed fault key for repair notes -- matches the 'other'-type row seeded in
// faults.csv (key: "REPAIR NOTE", short_code: "RN") for each make/model, so
// every repair note shares that one canonical fault instead of ensure_fault_row
// creating a new fault per note's free-text content.
export const REPAIR_NOTE_FAULT_KEY = 'REPAIR NOTE'
